import cloneDeep from 'lodash/cloneDeep';

import BlockSettingsSchema from '@plone/volto/components/manage/Blocks/Block/Schema';
import applicationSVG from '@plone/volto/icons/application.svg';
import IframeView from './components/Blocks/Iframe/View';
import IframeEdit from './components/Blocks/Iframe/Edit';

import ScriptView from './components/Blocks/Script/View';
import ScriptEdit from './components/Blocks/Script/Edit';

import PreFooter from './components/Footer/PreFooter';

const applyConfig = (config) => {
  config.settings = {
    ...config.settings,
    isMultilingual: false,
    supportedLanguages: ['en'],
    viewableInBrowserObjects: ['File'],
    downloadableObjects: [''],
    defaultLanguage: 'en',
    enableFatMenu: false,
    matomoSiteId: '2',
    matomoUrlBase: 'https://piwik.cleanclothes.org/',
  };
  config.blocks.themes = [
    {
      style: {
        '--theme-color': '#fffaf5',
        '--theme-high-contrast-color': '  #d2de48',
        '--theme-foreground-color': '#000',
        '--theme-low-contrast-foreground-color': '#555555',
      },
      name: 'default',
      label: 'Default',
    },
    {
      style: {
        '--theme-color': ' #d2de48',
        '--theme-high-contrast-color': '#fffaf5',
        '--theme-foreground-color': '#000',
        '--theme-low-contrast-foreground-color': '#555555',
      },
      name: 'grey',
      label: 'Green',
    },
  ];

  config.registerSlotComponent({
    name: 'preFooter',
    slot: 'preFooter',
    component: PreFooter,
  });

  config.reorderSlotComponent({
    name: 'preFooter',
    slot: 'preFooter',
    action: 'before',
    target: 'footerLogos',
  });

  config.blocks.blocksConfig.iframe = {
    id: 'iframe',
    title: 'Iframe',
    icon: applicationSVG,
    group: 'common',
    view: IframeView,
    edit: IframeEdit,
    schema: BlockSettingsSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.settings.DSGVOBanner = {
    ...(config.settings.DSGVOBanner || {}),
    modules: ['thirdparty'],
    tracker: {
      type: 'matomo',
      urlBase: 'https://piwik.cleanclothes.org/',
      id: 2,
    },
    showHelpTextForOptions: true,
    cssClasses: {
      bannerAgreeButton: 'branded blue',
      bannerAgreeEssentialButton: 'branded olive',
      bannerAdjustButton: 'branded blue',
    },
  };

  config.blocks.blocksConfig.script = {
    id: 'script',
    title: 'Script',
    icon: applicationSVG,
    group: 'common',
    view: ScriptView,
    edit: ScriptEdit,
    schema: BlockSettingsSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  /**
   * Enable 'iframe', '__button' and 'heading' blocks
   * to be used in 'gridBlock'
   */
  config.blocks.blocksConfig.gridBlock.blocksConfig.iframe = cloneDeep(
    config.blocks.blocksConfig.iframe,
  );
  config.blocks.blocksConfig.gridBlock.allowedBlocks.push('iframe');

  config.blocks.blocksConfig.gridBlock.blocksConfig.__button = cloneDeep(
    config.blocks.blocksConfig.__button,
  );
  config.blocks.blocksConfig.gridBlock.allowedBlocks.push('__button');

  config.blocks.blocksConfig.gridBlock.blocksConfig.heading = cloneDeep(
    config.blocks.blocksConfig.heading,
  );
  config.blocks.blocksConfig.gridBlock.allowedBlocks.push('heading');

  config.blocks.requiredBlocks = [];

  return config;
};

export default applyConfig;
